import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "list-available-cards" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "list-available-cards__radio m-right-15" }, null, -1)
const _hoisted_4 = { class: "icon-card-brand m-right-15" }
const _hoisted_5 = { class: "list-available-cards__number" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "credit-card__dots--dot" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "credit-card__dots--dot" }, null, -1)
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SimpleModal = _resolveComponent("SimpleModal")!
  const _component_IconsCardBrand = _resolveComponent("IconsCardBrand")!
  const _component_IconRemove = _resolveComponent("IconRemove")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.isShowModalDeletePM)
      ? (_openBlock(), _createBlock(_component_SimpleModal, {
          key: 0,
          title: "Delete payment method",
          subtitle: "Are you sure you want to delete this payment method?",
          buttons: _ctx.modalDeletePMButtons,
          onAction: _ctx.handleActionDeleteModal,
          onClose: _ctx.closeDeletePMModals
        }, null, 8, ["buttons", "onAction", "onClose"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$props.list, (pm, id) => {
        return (_openBlock(), _createElementBlock("div", {
          role: "button",
          onClick: ($event: any) => (_ctx.handleSelectingPM(pm)),
          class: _normalizeClass(["list-available-cards__slot", {'active': _ctx.paymentMethod?.stripe_id === pm.stripe_id}]),
          key: id
        }, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_IconsCardBrand, {
              brand: pm.brand
            }, null, 8, ["brand"])
          ]),
          _createElementVNode("div", _hoisted_5, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (dot) => {
              return _createElementVNode("div", {
                class: "credit-card__dots",
                key: dot
              }, _hoisted_8)
            }), 64)),
            _createElementVNode("h3", null, _toDisplayString(pm.last4), 1)
          ]),
          (!pm.default || _ctx.cardExpire(pm))
            ? (_openBlock(), _createBlock(_component_IconRemove, {
                key: 0,
                class: "icon-remove",
                onClick: ($event: any) => (_ctx.handleShowModalDeletePM(pm))
              }, null, 8, ["onClick"]))
            : _createCommentVNode("", true)
        ], 10, _hoisted_2))
      }), 128))
    ])
  ], 64))
}